
module.filter('dolRegionName', function(dolRegions, dolRegionNames) {
    return function(state) {
        return dolRegions[state] && dolRegionsNames[dolRegions[state] - 1];
    };
});
